import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';

import { getErrorTranslations } from '@/locale/error-translations';

/**
 * Use in react components, we memoize the translations
 * to avoid re-rendering the same translations.
 */
export function useErrorTranslations() {
  const { t } = useLingui();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => getErrorTranslations(), [t]);
}
